/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector:not(.option-selector--custom)');
      this.nativeSelector = document.getElementById(`variants-${this.section.dataset.section}`);
      this.data = this.getVariantData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.skuHideList = [];

      this.init();
    }

    async init() {
      this.skuHideList = await this.fetchSkuHideList();
      this.updateAvailability();
      this.updateAddToCartButton();
      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.applySearchParams();
      this.setAttribute('loaded', '');
    }

    async fetchSkuHideList() {
      // Embedded SKU hide list - update this array when needed
      const skuHideList = [
        "49893",
        "40036",
        "49947",
        "24502",
        "24461",
        "49796",
        "25444",
        "17892",
        "62359",
        "28980",
        "28979",
        "49905",
        "28982",
        "49909",
        "28981",
        "28984",
        "28978",
        "24441",
        "49771",
        "19668",
        "19670",
        "56357",
        "78776",
        "21609",
        "62627S",
        "62627C",
        "62627G",
        "62627A",
        "62627N",
        "62627P",
        "62627R",
        "62627Q",
        "62627B",
        "62627H",
        "62627D",
        "62627J",
        "62627L",
        "62627T",
        "62627M",
        "62627F",
        "62627K",
        "62627E",
        "61706",
        "61707",
        "63090",
        "63089",
        "47693",
        "47695",
        "47694",
        "44802",
        "47676",
        "41953",
        "48160",
        "48161",
        "61318",
        "64581",
        "64567",
        "45675",
        "52337",
        "52336",
        "81238",
        "65531",
        "65259",
        "52267",
        "74508",
        "74492",
        "62315",
        "51458",
        "53101",
        "74642",
        "44181",
        "40126",
        "47888",
        "62309",
        "23576",
        "28482",
        "64294",
        "24603",
        "42283",
        "61205",
        "78047",
        "65592",
        "65594",
        "65591",
        "52301",
        "51519",
        "24140",
        "24138",
        "25100",
        "24535",
        "52974",
        "22387",
        "74344",
        "52957",
        "52954",
        "52932",
        "52985",
        "52970",
        "68505",
        "49434",
        "63828",
        "79760",
        "77484",
        "61682",
        "61684",
        "61675",
        "25737",
        "65536",
        "78366",
        "61397",
        "26344",
        "41945",
        "72047",
        "72049",
        "72048",
        "72046",
        "72050",
        "49735",
        "69207",
        "61939",
        "24563",
        "24566",
        "61629",
        "61630",
        "61627",
        "47432",
        "47433",
        "47437",
        "47431",
        "26344Q",
        "48495",
        "26344P",
        "26344N",
        "72056",
        "72055",
        "72057",
        "72058",
        "78984",
        "78981",
        "78980",
        "79047",
        "78979",
        "22700",
        "22656",
        "26344L",
        "62577",
        "62578",
        "68507",
        "65568",
        "65569",
        "78438",
        "93095",
        "93098",
        "77441",
        "26891",
        "65570",
        "65571",
        "51700",
        "51701",
        "51702",
        "51703",
        "51704",
        "51705",
        "51708",
        "67938",
        "60294",
        "21228",
        "78270",
        "47768",
        "51821",
        "79289",
        "64675",
        "65532",
        "41727",
        "41723",
        "60430",
        "61673",
        "74175",
        "44997",
        "24318",
        "24315",
        "48797",
        "48795",
        "24316",
        "61535",
        "25216",
        "61770",
        "20038",
        "41463",
        "23640",
        "80244",
        "41829",
        "82220",
        "40252",
        "78000",
        "69605",
        "69604",
        "69603",
        "69608",
        "69606",
        "69607",
        "74174",
        "64711",
        "41227G",
        "41227F",
        "41227A",
        "32626",
        "65004",
        "52449",
        "32452",
        "52764",
        "23874",
        "63961",
        "80243",
        "81610",
        "78903",
        "79624",
        "79632",
        "74949",
        "78618",
        "24306",
        "48814",
        "74398",
        "68300",
        "79458",
        "51940",
        "42224",
        "48749",
        "60283",
        "23887",
        "64165",
        "40822",
        "13553",
        "23323",
        "61398",
        "78779",
        "78686",
        "41712",
        "62430",
        "52306",
        "72051",
        "72054",
        "47855",
        "25285",
        "79514",
        "74356",
        "74322",
        "60370",
        "62841",
        "79677",
        "61324",
        "77384",
        "61725",
        "61724",
        "21715",
        "25757",
        "61651",
        "23657",
        "65540",
        "65544",
        "65543",
        "60035",
        "60037",
        "47564",
        "47565",
        "69611",
        "69610",
        "69609",
        "69615",
        "74012",
        "80602",
        "26344E",
        "62466",
        "62460",
        "43486",
        "62439",
        "62443",
        "62550",
        "22762",
        "22761",
        "41831",
        "41833",
        "20879",
        "24783",
        "23854",
        "61762",
        "78568",
        "78569",
        "51125",
        "19754",
        "60171",
        "78565",
        "78594",
        "78599",
        "78597",
        "64882",
        "64883",
        "64884",
        "64885",
        "64887",
        "64888",
        "64890",
        "64892",
        "64896",
        "62599",
        "62987",
        "62609",
        "62615",
        "62600",
        "62616",
        "62617",
        "48833",
        "49014",
        "24179",
        "25880",
        "24153",
        "43269",
        "25860",
        "63578",
        "24443",
        "23987",
        "41052",
        "41051",
        "24002",
        "41824",
        "41825",
        "79012",
        "64274",
        "22380",
        "44420",
        "44474",
        "44414",
        "48865",
        "49425",
        "62448",
        "62446",
        "62455",
        "62456",
        "24574",
        "24573",
        "68506",
        "68508",
        "23878",
        "52146",
        "52540",
        "48543",
        "60029",
        "41447",
        "52317",
        "23862",
        "23864",
        "23868",
        "65071",
        "46534",
        "46521",
        "46536",
        "24669",
        "56462",
        "24659",
        "24462",
        "63345",
        "63344",
        "63346",
        "61638",
        "61045",
        "24335",
        "23327",
        "52428",
        "62469",
        "62476",
        "61703",
        "61702",
        "61704",
        "21927",
        "43490",
        "48956",
        "43489",
        "41964",
        "41965",
        "41967",
        "41969",
        "41970",
        "41972",
        "41973",
        "41975",
        "41976",
        "41977",
        "41979",
        "41980",
        "41981",
        "41982",
        "41983",
        "40831",
        "40833",
        "40834",
        "40835",
        "40837",
        "40838",
        "40839",
        "40840",
        "40841",
        "40842",
        "40843",
        "40846",
        "40847",
        "40848",
        "40850",
        "40852",
        "40877",
        "40878",
        "40879",
        "23882",
        "53022",
        "63705",
        "22859",
        "42171",
        "43430",
        "24424",
        "40139",
        "40136",
        "49327",
        "24308",
        "20545",
        "24280",
        "24609",
        "52684",
        "52685",
        "52682",
        "52688",
        "24578",
        "78003",
        "24149",
        "29561",
        "41820",
        "41394",
        "41398",
        "41397",
        "41445",
        "41346",
        "41359",
        "41354",
        "41402",
        "25631",
        "41348",
        "61763",
        "61774",
        "78344",
        "78346",
        "78350",
        "78343",
        "78345",
        "78347",
        "78348",
        "78349",
        "67149",
        "67168",
        "67199",
        "81566",
        "81612",
        "62041",
        "42383",
        "42387",
        "42375",
        "42379",
        "42404",
        "81575",
        "12973",
        "65528",
        "65521",
        "61767",
        "61766",
        "63124",
        "63126",
        "79576",
        "79334",
        "82078",
        "21729",
        "78625",
        "78229",
        "78228",
        "78232",
        "78231",
        "78230",
        "65578",
        "74090",
        "26493",
        "74023",
        "25977",
        "79053",
        "48484",
        "48474",
        "25698",
        "81274",
        "41948",
        "48935",
        "48932",
        "65575",
        "24517",
        "48950",
        "61617",
        "24505",
        "61615",
        "48949",
        "17556",
        "65574",
        "65572",
        "65558",
        "68492",
        "65589",
        "65590",
        "64521",
        "64532",
        "64505",
        "64504",
        "64502",
        "64503",
        "77454",
        "81345",
        "81346",
        "20520",
        "60547",
        "60551",
        "41917",
        "22600",
        "22542",
        "22539",
        "79209",
        "41089",
        "48158",
        "48159",
        "79201",
        "52995",
        "51515",
        "25435",
        "72122",
        "60712",
        "61434",
        "53004",
        "23873",
        "25152",
        "61394",
        "61393",
        "47627",
        "47514",
        "61723",
        "51377",
        "47632",
        "62692",
        "24897",
        "79016",
        "61659",
        "61742",
        "65587",
        "65586",
        "63581",
        "63583",
        "63582",
        "74699",
        "52293",
        "74168",
        "41781",
        "41782",
        "82031",
        "80676",
        "80675",
        "80674",
        "42291",
        "42292",
        "80671",
        "80672",
        "80673",
        "63084",
        "63703",
        "48969",
        "48985",
        "48987",
        "48989",
        "48990",
        "48992",
        "47657",
        "47658",
        "23852",
        "24077",
        "78046",
        "72131",
        "72130",
        "41280",
        "41281",
        "62306",
        "28496",
        "49605",
        "49604",
        "62325",
        "49596",
        "28603",
        "52547",
        "62326",
        "74504",
        "74505",
        "28608",
        "62323",
        "62324",
        "62318",
        "28578",
        "62322",
        "62317",
        "74509",
        "74493",
        "62320",
        "28586",
        "74506",
        "49594",
        "52548",
        "28634",
        "62321",
        "49606",
        "28501",
        "28582",
        "28607",
        "28633",
        "62319",
        "49603",
        "49592",
        "74503",
        "65580",
        "61710",
        "65551",
        "62631M",
        "62631G",
        "42317",
        "42312",
        "42318",
        "42326",
        "42328",
        "60559",
        "60563",
        "24258",
        "62547",
        "46014",
        "48057",
        "74907",
        "62410",
        "24343",
        "79046",
        "79044",
        "79045",
        "79048",
        "61639",
        "63548",
        "63549",
        "49723",
        "56312",
        "81263",
        "60158",
        "23248",
        "41812",
        "80552",
        "74312",
        "48204",
        "24281",
        "41739",
        "47726",
        "52967",
        "41827",
        "72142",
        "61540",
        "65557",
        "78816",
        "24448",
        "28739",
        "41826",
        "41802",
        "60073",
        "47727",
        "24282",
        "48829",
        "61544",
        "61092",
        "64289",
        "32617",
        "48513",
        "49722",
        "61091",
        "64166",
        "56167",
        "60670",
        "80578",
        "23880",
        "81656",
        "24934",
        "22655",
        "22649",
        "22658",
        "41956",
        "56353",
        "56356",
        "64197",
        "64198",
        "40767",
        "52444",
        "63364",
        "23938",
        "48716",
        "41741",
        "32556",
        "46452",
        "32457",
        "60188",
        "53181",
        "48535",
        "23891",
        "29917",
        "41622",
        "23746",
        "26161",
        "60434",
        "48674",
        "24672",
        "41621",
        "41601",
        "61608",
        "65562",
        "65563",
        "72234",
        "79477",
        "62625",
        "52644",
        "77522",
        "42310",
        "62147",
        "62145",
        "41835",
        "41836",
        "41834",
        "61399",
        "78317",
        "46776",
        "61040",
        "80857",
        "52405",
        "48672",
        "61257",
        "32587",
        "32586",
        "78792",
        "23244",
        "17039",
        "49677",
        "25238",
        "61657",
        "61656",
        "61717",
        "61719",
        "62043",
        "62042",
        "48381",
        "61217",
        "61222",
        "82017",
        "74691",
        "24338",
        "24658",
        "26683",
        "24996",
        "49110",
        "24016",
        "25302",
        "62352",
        "74283",
        "22559",
        "24583",
        "24534",
        "24094",
        "24340",
        "26805",
        "19658",
        "62023",
        "26344G",
        "78243",
        "21803",
        "32442",
        "74947",
        "61952",
        "61940",
        "25684",
        "24933",
        "52532",
        "61757",
        "61760",
        "52830",
        "52272",
        "24481",
        "32449",
        "63706",
        "65567",
        "47883",
        "24946",
        "24935",
        "79094",
        "79095",
        "79096",
        "61672",
        "40757",
        "60648",
        "60646",
        "62099",
        "53214",
        "41780",
        "52144",
        "52678",
        "47374",
        "26317",
        "64782",
        "78327",
        "78329",
        "78328",
        "78325",
        "78326",
        "52877",
        "63509",
        "63510",
        "52454",
        "52452",
        "61996",
        "69614",
        "24088",
        "41760",
        "48413",
        "40881",
        "24627",
        "19016",
        "19012",
        "19013",
        "19014",
        "19015",
        "19011",
        "80687",
        "47625",
        "61061",
        "61054",
        "60647",
        "61049",
        "79084",
        "64290",
        "47630",
        "52406",
        "82113",
        "22760",
        "52605",
        "82114",
        "79680",
        "49290",
        "32638",
        "32627",
        "26274",
        "42179",
        "78055",
        "78054",
        "25870",
        "78299",
        "78297",
        "78298",
        "49609",
        "49607",
        "28659",
        "49645",
        "62330",
        "49654",
        "74511",
        "74491",
        "26344H",
        "21443",
        "47471",
        "40801",
        "61674",
        "90026",
        "47200",
        "47199",
        "24557",
        "74383",
        "41828",
        "62505",
        "64191",
        "81626",
        "78738",
        "24177",
        "24176",
        "41417",
        "61539",
        "48487",
        "48488",
        "48642",
        "63096",
        "26189",
        "52151",
        "52147",
        "78761",
        "74193",
        "52724",
        "62506",
        "62508",
        "22538",
        "81340",
        "69212",
        "74872",
        "24191",
        "47562",
        "72021",
        "72033",
        "72031",
        "53092",
        "53220",
        "23869",
        "23863",
        "23867",
        "23865",
        "48542",
        "48540",
        "48541",
        "65096",
        "65090",
        "65074",
        "65128",
        "65124",
        "32619",
        "62559",
        "26159",
        "79125",
        "79763",
        "69629",
        "45732",
        "74351",
        "25624",
        "25620",
        "25625",
        "27686",
        "42346",
        "74869",
        "24513",
        "53040",
        "53055",
        "53051",
        "52993",
        "53047",
        "53053",
        "53056",
        "78314",
        "53084",
        "53081",
        "42182A",
        "42182B",
        "42182C",
        "42182D",
        "42182E",
        "42182F",
        "42182G",
        "42182H",
        "42182J",
        "42182K",
        "42182L",
        "42182M",
        "42182N",
        "42182P",
        "42182R",
        "42182S",
        "42182T",
        "42182V",
        "42182W",
        "60554",
        "42333",
        "42332",
        "42334",
        "24963",
        "42341",
        "42335",
        "42339",
        "42338",
        "78263",
        "78262",
        "78260",
        "78261",
        "78264",
        "23937",
        "52251",
        "78611",
        "78610",
        "41854",
        "24392",
        "81343",
        "22318",
        "41818",
        "41819",
        "22585",
        "81764A",
        "81764C",
        "81764B",
        "41244",
        "64225",
        "79245",
        "61238",
        "64231",
        "64850",
        "46910",
        "21907",
        "68493",
        "68496",
        "68488",
        "68489",
        "68487",
        "28740",
        "23756",
        "28665",
        "74500",
        "78030",
        "78028",
        "25197",
        "78029",
        "78214",
        "78215",
        "25215",
        "60959",
        "79364",
        "52318",
        "42931",
        "43165",
        "64242",
        "74729",
        "32458",
        "72028",
        "72029",
        "72026",
        "72027",
        "72030",
        "17614",
        "23888",
        "79727",
        "22187",
        "48334",
        "79455",
        "72153",
        "79390",
        "43755",
        "21236",
        "40268",
        "72144",
        "56561",
        "81622",
        "74033",
        "24713",
        "24722",
        "48798",
        "72040",
        "72044",
        "24287",
        "25724",
        "25728",
        "80667",
        "80670",
        "42192",
        "42195",
        "63541",
        "25244G",
        "25244H",
        "25244I",
        "25244J",
        "25244L",
        "25244M",
        "25244N",
        "25244P",
        "25244Q",
        "25244R",
        "25244S",
        "25244U",
        "25244V",
        "25244W",
        "25244X",
        "25244Y",
        "25244Z",
        "25335",
        "25012",
        "25018",
        "25011",
        "25017",
        "25013",
        "25015",
        "42183",
        "41822",
        "42184",
        "24527",
        "24530",
        "24529",
        "24528",
        "26353",
        "26407",
        "80221",
        "25174",
        "25137",
        "25142",
        "42368",
        "72152",
        "64232",
        "65548",
        "81397",
        "48613",
        "53136",
        "72075",
        "74165",
        "74164",
        "74063",
        "72124",
        "23493",
        "23497",
        "23491",
        "42322",
        "81398",
        "41838",
        "41839",
        "24937",
        "61730",
        "61728",
        "65545",
        "42320",
        "41400",
        "27692",
        "48999",
        "61744",
        "24703",
        "78363",
        "72108",
        "72107",
        "72109",
        "72110",
        "72111",
        "72112",
        "72113",
        "72114",
        "72115",
        "72116",
        "72117",
        "72118",
        "72095",
        "72097",
        "72098",
        "72100",
        "72101",
        "72102",
        "72104",
        "72105",
        "43105",
        "74347",
        "79300",
        "79301",
        "79302",
        "23195",
        "16273",
        "16274",
        "63555",
        "61765",
        "61667",
        "46474",
        "46460",
        "46473",
        "74316",
        "42324",
        "42323",
        "74317",
        "74315",
        "24639",
        "24615",
        "24490",
        "46725",
        "12633",
        "61468",
        "60697",
        "42309",
        "61471",
        "79226",
        "79227",
        "79224",
        "60785",
        "24640",
        "24641",
        "41339",
        "41340",
        "41341",
        "60704",
        "63579",
        "41811",
        "41813",
        "26030",
        "24120",
        "21240",
        "14397",
        "41345",
        "80757",
        "22772",
        "51818",
        "65555",
        "22597",
        "80755",
        "80756",
        "64223",
        "81613",
        "47436",
        "46520",
        "48617",
        "42433",
        "24634",
        "74878",
        "63818",
        "61931A",
        "63652A",
        "25628",
        "25629",
        "25626",
        "74118",
        "62387",
        "62386",
        "61427",
        "61426",
        "61428",
        "61947",
        "61944",
        "61945",
        "42181",
        "29053",
        "62512",
        "61083",
        "78222",
        "78220",
        "78218",
        "78221",
        "25020",
        "78219",
        "61338",
        "61336",
        "61337",
        "61335",
        "24718",
        "24251",
        "22775",
        "61401",
        "24532",
        "24531",
        "24533",
        "61593",
        "68500",
        "68499",
        "68502",
        "49663",
        "47566",
        "47737",
        "47567",
        "47568",
        "47569",
        "47576",
        "47607",
        "47608",
        "47741",
        "47740",
        "47609",
        "47616",
        "47629",
        "47649",
        "47659",
        "47662",
        "47664",
        "47678",
        "47679",
        "40001",
        "78123",
        "78132",
        "78138",
        "78076",
        "78077",
        "78078",
        "78079",
        "78080",
        "78081",
        "78082",
        "78083",
        "78084",
        "78085",
        "78086",
        "78087",
        "78088",
        "78089",
        "78090",
        "78091",
        "78092",
        "78093",
        "78094",
        "78095",
        "78096",
        "78098",
        "78108",
        "78109",
        "69618",
        "41448",
        "41449",
        "25224",
        "23847",
        "24122",
        "24119",
        "61455",
        "23758",
        "24206",
        "41429",
        "41426",
        "24678",
        "23649",
        "21239",
        "79668",
        "69107",
        "61389",
        "61391",
        "42327",
        "24154",
        "24164",
        "24147",
        "21457",
        "79432",
        "26788",
        "50463",
        "28469",
        "26309",
        "61065",
        "79720",
        "26512",
        "62332",
        "80661",
        "42065",
        "45287",
        "61769",
        "23859",
        "74510",
        "62307",
        "67936",
        "62358",
        "62208",
        "53217",
        "53218",
        "47495",
        "47496",
        "79601",
        "79603",
        "79602",
        "24092",
        "60703",
        "69601",
        "69602",
        "64196",
        "64195",
        "74855",
        "61067",
        "43835",
        "74100",
        "52765",
        "23960",
        "48162",
        "79231",
        "23877",
        "41949",
        "69104",
        "52859",
        "41323",
        "41326",
        "32489",
        "41324",
        "22809",
        "22764",
        "22759",
        "41321",
        "25576",
        "41334",
        "41335",
        "32589",
        "41333",
        "52303",
        "41310",
        "41309",
        "41311",
        "41307",
        "41308",
        "41306",
        "78535",
        "78534",
        "78537",
        "78538",
        "78539",
        "78540",
        "78541",
        "61296",
        "78784",
        "78783",
        "72084",
        "72083",
        "72085",
        "72086",
        "72087",
        "72088",
        "72089",
        "72090",
        "72091",
        "72092",
        "72093",
        "72094",
        "52991",
        "51101",
        "42150",
        "27581",
        "27593",
        "27595",
        "27418",
        "27601",
        "27583",
        "61143",
        "81764J",
        "81764H",
        "81764I",
        "81764G",
        "21393",
        "63701",
        "63693",
        "21391",
        "81730",
        "81729",
        "81736",
        "81727",
        "81741",
        "81739",
        "61149",
        "61405",
        "61150",
        "61192",
        "63447",
        "23489",
        "51439",
        "47476",
        "49683",
        "42851",
        "24387",
        "60030",
        "41146",
        "52562",
        "52564",
        "62592",
        "22302",
        "22301",
        "41025",
        "41022",
        "41021",
        "17515",
        "17536",
        "42760",
        "61915",
        "60626",
        "43339",
        "63410",
        "40137",
        "40289",
        "24389",
        "69041",
        "25345",
        "22345",
        "27827",
        "24587",
        "51869",
        "46805",
        "44642",
        "45428",
        "49201",
        "45391",
        "41186",
        "44780",
        "47256",
        "49431",
        "60177",
        "48722",
        "41034",
        "29355",
        "61871",
        "22018",
        "48306",
        "61202",
        "28208",
        "41910",
        "25064",
        "44904",
        "28432",
        "79120",
        "52561",
        "52559",
        "62035",
        "52647",
        "61339",
        "61489",
        "61341",
        "62464",
        "29569",
        "24493",
        "40146",
        "40159",
        "45999",
        "45899",
        "41762",
        "61496",
        "25732",
        "63448",
        "63449",
        "45400",
        "45401",
        "22529",
        "45436",
        "52812",
        "61529",
        "48856",
        "79131",
        "52557",
        "49559",
        "23122",
        "26623",
        "26576",
        "26655",
        "25217",
        "29252",
        "25310",
        "29577",
        "24073",
        "48860",
        "43682",
        "48993",
        "45930",
        "45917",
        "40009",
        "48690",
        "48688",
        "23952",
        "79123",
        "24414",
        "24637",
        "45478",
        "79126",
        "48456",
        "62086",
        "62087",
        "48719",
        "62497",
        "22888",
        "40802",
        "63076",
        "61493",
        "22514",
        "47674",
        "52253",
        "47672",
        "62817",
        "22388",
        "24921",
        "24920",
        "61248",
        "63995",
        "62463",
        "69022",
        "32542",
        "32503",
        "43721",
        "43796",
        "25098",
        "25381",
        "26572",
        "25379",
        "23981",
        "23980",
        "61515",
        "52813",
        "48761",
        "28990",
        "22886",
        "25300",
        "22793",
        "62299",
        "62296",
        "45476",
        "24048",
        "24047",
        "24661",
        "24644",
        "22527",
        "64187",
        "22295",
        "49514",
        "46012",
        "29813",
        "42745",
        "40758",
        "45018",
        "62010",
        "62008",
        "21954",
        "48994",
        "61957",
        "41016",
        "49702",
        "26221",
        "49058",
        "48512",
        "61582",
        "41095",
        "62310",
        "27809",
        "25762",
        "22563",
        "60187",
        "23501",
        "79129",
        "23539",
        "48304",
        "46010",
        "24746",
        "60133",
        "60143",
        "24418",
        "48601",
        "48648",
        "24364",
        "45711",
        "52400",
        "52398",
        "52396",
        "40455",
        "40445",
        "49724",
        "45255",
        "45264",
        "61433",
        "60303",
        "60304",
        "60897",
        "48596",
        "29439",
        "47164",
        "40169",
        "23306",
        "60065",
        "23236",
        "29335",
        "47925",
        "49701",
        "45754",
        "23757",
        "47624",
        "23739",
        "48533",
        "61795",
        "24579",
        "24572",
        "25301",
        "61932",
        "42940",
        "23526",
        "24735",
        "60962",
        "49068",
        "48455",
        "52579",
        "52581",
        "52447",
        "52450",
        "49286",
        "49375",
        "49093",
        "49284",
        "49285",
        "49112",
        "49113",
        "41443",
        "41103",
        "48424",
        "45454",
        "45122",
        "45112",
        "61209",
        "41535",
        "41619",
        "41643",
        "41648",
        "25248",
        "60993",
        "24664",
        "24667",
        "23982",
        "23983",
        "22545",
        "61926",
        "61927",
        "47275",
        "61043",
        "41126",
        "25359",
        "25354",
        "47729",
        "47730",
        "62130",
        "49376",
        "48881",
        "32557",
        "74498",
        "74499",
        "74496",
        "74497",
        "62749",
        "69042",
        "41600",
        "48849",
        "48868",
        "49118",
        "61930",
        "48848",
        "48867",
        "48869",
        "49119",
        "48731",
        "61343",
        "61361",
        "61293",
        "61292",
        "61499",
        "64168",
        "48564",
        "48594",
        "49700",
        "61294",
        "49255",
        "49249",
        "49266",
        "49246",
        "46118",
        "26547",
        "24807",
        "62026",
        "60964",
        "60496",
        "48658",
        "48662",
        "49013",
        "32519",
        "21409",
        "48152",
        "47722",
        "40254",
        "40258",
        "45813",
        "63904",
        "62582",
        "63492",
        "63493",
        "22949",
        "52357",
        "52792",
        "52704",
        "61580",
        "52716",
        "62335",
        "52549",
        "61797",
        "40738",
        "62148",
        "48600",
        "48599",
        "48569",
        "48568",
        "41605",
        "60774",
        "49098",
        "49100",
        "24738",
        "24737",
        "24800",
        "27672",
        "79134",
        "25313",
        "52729",
        "24320",
        "61954",
        "61953",
        "45399",
        "60858",
        "61121",
        "61921",
        "62066",
        "61925",
        "21914",
        "61254",
        "42924",
        "63782",
        "26574",
        "42796",
        "41187",
        "48751",
        "61519",
        "69074",
        "24269",
        "43613",
        "48745",
        "25185",
        "80581",
        "62277",
        "25078",
        "64222",
        "61452",
        "23742",
        "61867",
        "61850",
        "25351",
        "74526",
        "49004",
        "49007",
        "22892",
        "22889",
        "25999",
        "25995",
        "41013",
        "49089",
        "49088",
        "45458",
        "23245",
        "48414",
        "24700",
        "41272",
        "48534",
        "42764",
        "46122",
        "46037",
        "46120",
        "63991",
        "63984",
        "24740",
        "24804",
        "21018",
        "61408",
        "44047",
        "47647",
        "49274",
        "49283",
        "49282",
        "61457",
        "61458",
        "28479",
        "74512",
        "61870",
        "62069",
        "61854",
        "61864",
        "22447",
        "32490",
        "61297",
        "78990",
        "44899",
        "52926",
        "48075",
        "48071",
        "44305",
        "60241",
        "21265",
        "65405",
        "38796",
        "28774",
        "61799",
        "38450",
        "37992",
        "28800",
        "22146",
        "48502",
        "61319",
        "40611",
        "22965",
        "60252",
        "53824",
        "49766",
        "49768",
        "44476",
        "27529",
        "44477",
        "52925",
        "60396",
        "60392",
        "60409",
        "26196",
        "44796",
        "33606",
        "44097",
        "61800",
        "52803",
        "49769",
        "44090",
        "44745",
        "21672",
        "38226",
        "52796",
        "38218",
        "27053",
        "52783",
        "53435",
        "27899",
        "27054",
        "37980",
        "63197",
        "67131",
        "40402",
        "37987",
        "27491",
        "43018",
        "39413",
        "22143",
        "25401",
        "22144",
        "34878",
        "22155",
        "37984",
        "14621",
        "14614",
        "14629",
        "14616",
        "14618",
        "14602",
        "77542",
        "94231",
        "94378",
        "93159",
        "91215",
        "93161",
        "91314",
        "93008",
        "91166",
        "91163",
        "91164",
        "93039",
        "93040",
        "96021",
        "92111",
        "91125",
        "91233",
        "97006",
        "91289",
        "93026",
        "96009",
        "97000",
        "97004",
        "91238",
        "91255",
        "91395",
        "96031",
        "91279",
        "92126",
        "92123",
        "92124",
        "92125",
        "91209",
        "93163",
        "91291",
        "95274",
        "95140",
        "95141",
        "95142",
        "95143",
        "65506",
        "93034",
        "91280",
        "93016",
        "91310",
        "96027",
        "94301",
        "92108",
        "91191",
        "91249",
        "91254",
        "94214",
        "96020",
        "96018",
        "93031",
        "95339",
        "95144",
        "93025",
        "92116I",
        "92116G",
        "92116H",
        "92116C",
        "92116F",
        "92116E",
        "94313",
        "94261",
        "94260",
        "94169",
        "78210",
        "93178",
        "92286",
        "92287",
        "92289",
        "92290",
        "92291",
        "95338",
        "93027",
        "94215",
        "94226",
        "93028",
        "91240",
        "96053",
        "93135",
        "79007",
        "78995",
        "79000",
        "79006",
        "91355",
        "92105",
        "92103",
        "94217",
        "94219",
        "91211",
        "91173",
        "91285",
        "91180",
        "91195",
        "91245",
        "91282",
        "94314",
        "91256",
        "91246",
        "93160",
        "91242",
        "95107",
        "52270",
        "21217",
        "74469",
        "52122",
        "52152",
        "60638",
        "52114",
        "60714",
        "74286",
        "74292",
        "22569",
        "22571",
        "52115",
        "52158",
        "60641",
        "61011",
        "21824",
        "21823",
        "21830",
        "74285",
        "23010",
        "48134",
        "60644",
        "21826",
        "63584",
        "52909",
        "52036",
        "22420",
        "22421",
        "22415",
        "22414",
        "60658",
        "52910",
        "47400",
        "52125",
        "48135",
        "63616",
        "52154",
        "42069",
        "42049",
        "42057",
        "21194",
        "21205",
        "20716",
        "21156",
        "60633",
        "52119",
        "21789",
        "52911",
        "63615",
        "42048",
        "21794",
        "22418",
        "52121",
        "22407",
        "22408",
        "49164",
        "49163",
        "49137",
        "49138",
        "52901",
        "52316",
        "23009",
        "74288",
        "60659",
        "21795",
        "21792",
        "52156",
        "60636",
        "52155",
        "60657",
        "52124"
      ];
      

      return skuHideList;
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.updateUrl(evt);
      this.updateVariantInput();
      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateBarcode();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          allVariants: this.data.variants,
          selectedOptions: this.selectedOptions
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and status.
     */
    updateAddToCartButton() {
      if (!this.productForm) return;
      if (this.selectedOptions.indexOf(null) > -1) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      
      if (!this.variant) {
        this.addBtn.textContent = theme.strings.noVariant;
      } else if (this.variant.available) {
        this.addBtn.textContent = this.addBtn.dataset.addToCartText;
      } else if (this.skuHideList.includes(this.variant.sku)) {
        this.addBtn.textContent = theme.strings.noVariant;
      } else {
        this.addBtn.textContent = theme.strings.noStock;
      }
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    updateOptionAvailability(optionEl, exists, available, sku) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      

      // Only hide if the variant is unavailable AND its SKU is in the hide list
      if (!available && sku && this.skuHideList.includes(sku)) {
        // Mark as unavailable and specifically flagged by SKU rule
        el.classList.add('is-unavailable');
        el.classList.add('is-unavailable--by-sku');
      } else {
        // Ensure any previous flags are removed when available or not in SKU list
        el.classList.remove('is-unavailable');
        el.classList.remove('is-unavailable--by-sku');
      }
      
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.availability === 'off') return;
      

      // First, dispatch events for all sold-out variants on the hide list
      this.data.variants.forEach((variant) => {
        if (!variant.available && this.skuHideList.includes(variant.sku)) {

          this.dispatchEvent(new CustomEvent('on:variant:unavailable', {
            bubbles: true,
            detail: { variant },
          }));
        }
      });
      
      const { availabilityMode } = this.dataset; // 'down' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMode === 'selection') {
        // Flag all options as unavailable initially
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          this.updateOptionAvailability(optionEl, false, false, null);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                this.updateOptionAvailability(optionEl, true, variant.available, variant.sku);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            let variantsExist = false;
            let variantsAvailable = false;
            let firstMatchingVariant = null;
            
            this.data.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (!firstMatchingVariant) firstMatchingVariant = v;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            
            this.updateOptionAvailability(option, variantsExist, variantsAvailable, firstMatchingVariant?.sku);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the colour option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price .price');
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.variants[0];
        for (let i = 1; i < this.data.variants.length; i += 1) {
          if (this.data.variants[i].price < variant.price) variant = this.data.variants[i];
        }
      }

      if (variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
        if (priceWasEl) priceWasEl.innerHTML = this.data.formatted[variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = variant.unit_price_measurement.reference_value;
          const unit = variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          unitPriceEl.hidden = false;
        } else if (unitPriceEl) {
          unitPriceEl.hidden = true;
        }

        this.price.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
        this.price.classList.toggle('price--sold-out', !variant.available && !this.preSelection);
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.product-barcode__value');
      if (!this.barcode) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
      this.barcode.parentNode.hidden = !barcodeAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      const url = this.variant ? `${this.dataset.url}?variant=${this.variant.id}` : this.dataset.url;
      window.history.replaceState({ }, '', url);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('[name="id"]');
        input.value = this.variant ? this.variant.id : '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the variant data for a product.
     * @returns {?object}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get the selected values from a list of variant options.
     * @returns {Array} Array of selected option values, value is null if not selected.
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      return this.data.variants.find(
        (v) => v.options.every((val, index) => val === this.selectedOptions[index])
      );
    }

    /**
     * Apply search parameters.
     */
    applySearchParams() {
      const searchParams = new URLSearchParams(window.location.search);

      Array.from(searchParams.keys()).forEach((key) => {
        const value = searchParams.get(key);
        const optionSelectors = Array.from(this.optionSelectors);
        const matchingOptionSelector = optionSelectors.find((x) => x.dataset.option === key);
        if (!matchingOptionSelector) return;

        if (matchingOptionSelector.dataset.selectorType === 'dropdown') {
          const colorOptionDropdown = matchingOptionSelector.querySelector(`.custom-select__option[data-value="${value}"]`);
          if (colorOptionDropdown) {
            const customSelect = colorOptionDropdown.closest('custom-select');
            customSelect.selectOption(colorOptionDropdown);
          }
        } else {
          const matchingInput = matchingOptionSelector.querySelector(`input[value="${value}"]`);
          if (matchingInput) {
            const matchingOptionValue = matchingOptionSelector.querySelector('.option-selector__label-value');
            if (matchingOptionValue) {
              matchingOptionSelector.querySelector('.option-selector__label-value').textContent = value;
            }
            matchingInput.checked = true;
            matchingInput.dispatchEvent(
              new CustomEvent('change', { bubbles: true, cancelable: false })
            );
          }
        }
      });
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
